import { useEffect, useRef } from 'react'
import { isTrustpilotRatingEnabled } from '@lib/utils/feature-flag'

declare global {
  interface Window {
    Trustpilot: any
  }
}

type TrustBoxProps = {
  isDarkText?: boolean
  isCarousel?: boolean
}

const TrustBox = ({
  isDarkText = false,
  isCarousel = false,
}: TrustBoxProps) => {
  const ref = useRef(null)
  const component = {
    mini: {
      'data-template-id': '53aa8807dec7e10d38f59f32',
      'data-businessunit-id': '5f6b8ef03037cb000193cd80',
      'data-style-height': '90px',
      'data-style-width': '120px',
      'data-token': '552381e0-25c0-4fe8-9d3c-2d11f0317086',
      'data-theme': isDarkText ? 'light' : 'dark',
    },
    carousel: {
      'data-template-id': '54ad5defc6454f065c28af8b',
      'data-businessunit-id': '5f6b8ef03037cb000193cd80',
      'data-style-height': '240px',
      'data-style-width': '100%',
      'data-token': '5a6a9777-da37-4235-95e8-801523d4d4c1',
      'data-theme': isDarkText ? 'light' : 'dark',
      'data-stars': '5',
    },
  }
  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [isCarousel])
  if (!isTrustpilotRatingEnabled()) return null
  return (
    <>
      {
        <div
          ref={ref}
          className={`trustpilot-widget ${!isCarousel && '-mt-1'}`}
          data-locale="en-US"
          {...component[isCarousel ? 'carousel' : 'mini']}
        >
          <a
            href="https://www.trustpilot.com/review/www.codingal.com"
            target="_blank"
            rel="noreferrer"
          >
            Trustpilot
          </a>
        </div>
      }
    </>
  )
}
export default TrustBox
